module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CN ParaOverride-1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi",
      "title": "xi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocFMEM"
  }, [_c('a', {
    attrs: {
      "href": "#/PM#_idTextAnchor004"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Introduction")])]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(": Priestess of the Morrigan ")])]), _vm._v(" "), _c('p', {
    staticClass: "tocPT"
  }, [_c('a', {
    attrs: {
      "href": "#/PM1#_idTextAnchor005"
    }
  }, [_vm._v("Part 1")]), _vm._v(": The Nature of the Morrigan")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM2#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 1")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" The Morrigan: Who She Is and Who She Isn’t  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM3#_idTextAnchor007"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 2")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Belly Full of Blood: The Morrigan and War  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM4#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 3")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Victory and Healing  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM5#_idTextAnchor009"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 4")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Not for a Woman’s Backside: Sex and the Morrigan  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM6#_idTextAnchor010"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 5")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" The Price of a Crown: Goddess of Sovereignty  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM7#_idTextAnchor011"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 6")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Invoking the Peace: "), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Battlefield Devotions  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocPT"
  }, [_c('a', {
    attrs: {
      "href": "#/PM8#_idTextAnchor014"
    }
  }, [_vm._v("Part 2")]), _vm._v(": Vision and Prophecy")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('span', {
    staticClass: "med"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/PM9#_idTextAnchor015"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 7")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Becoming the Vessel: Visionary Work and the Morrigan  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM10#_idTextAnchor019"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 8")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" The Morrigan’s Wolves: A Vision Regarding Community ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM11#_idTextAnchor020"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 9")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Poisonous Hearts: A Vision of Serpents  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM12#_idTextAnchor021"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 10")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" UPG and the Morrigan  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocPT"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "href": "#/PM13#_idTextAnchor022"
    }
  }, [_vm._v("Part 3")]), _vm._v(": Devotions and Oaths")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM14#_idTextAnchor023"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 11")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Initiations  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM15#_idTextAnchor024"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 12")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Devotional Work  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM16#_idTextAnchor026"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 13")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" The Halidom of Macha: Oaths and Vows  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocPT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexii",
      "title": "xii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PM17#_idTextAnchor028"
    }
  }, [_vm._v("Part 4")]), _vm._v(": Sorcery and Ritual Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM18#_idTextAnchor029"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 14")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" She Sung Spells of Power:   Curse Work and the Morrigan ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM19#_idTextAnchor030"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 15")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Ritual Dynamics  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocCh"
  }, [_c('a', {
    attrs: {
      "href": "#/PM20#_idTextAnchor034"
    }
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 16")])]), _c('span', {
    staticClass: "med"
  }, [_vm._v(":")]), _vm._v(" Group Rituals  ")]), _vm._v(" "), _c('p', {
    staticClass: "tocFMEM"
  }, [_c('a', {
    attrs: {
      "href": "#/PM21#_idTextAnchor036"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocFMEM"
  }, [_c('a', {
    attrs: {
      "href": "#/PM22#_idTextAnchor039"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Appendix:")])]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Irish Myths and Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "tocFMEM"
  }, [_c('a', {
    attrs: {
      "href": "#/PM23#_idTextAnchor040"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ddcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0